<template>
  <div class="card rounded-4">
    <div class="card-body">
      <div class="d-flex align-items-center mb-4">
        <img
          :src="rating.formatted_profile_image"
          alt=""
          height="40"
          width="40"
          class="rounded-circle me-2"
        />
        <div>
          <p class="mb-1 text-subtitle">
            {{ rating.user.name.split(" ")[0] }}
          </p>
          <p class="text-label mb-0">
            {{ rating.formatted_date }}
          </p>
        </div>
        <div class="ms-auto">
          <!-- <p
                  class="text-subtitle text-warning"
                  v-if="rating?.review_requested && !rating?.reviewed_by"
                >
                  Em análise
                </p>
                <p
                  v-else-if="!rating?.reviewed_by"
                  class="text-subtitle text-muted cursor-pointer"
                  @click="handleReport(rating)"
                >
                  Reportar
                </p> -->
          <p
            class="text-subtitle text-danger cursor-pointer"
            @click="onRemove(rating.id)"
          >
            Reportar
            <i class="fa-solid fa-trash-alt"></i>
          </p>
        </div>
      </div>
      <p class="text-paragraph text-wrap">{{ rating.testimonial }}</p>
      <hr />

      <div class="d-flex align-items-center justify-content-between">
        <p class="text-paragraph mb-0">
          Este depoimento está<br />
          <span class="text-subtitle">{{
            rating.active ? "aparecendo" : "oculto"
          }}</span>
          no seu perfil
        </p>

        <span
          v-if="rating.submitting"
          class="spinner-border spinner-border-sm me-2 text-secondary"
          role="status"
          aria-hidden="true"
        ></span>
        <SwitchInput
          v-else
          :id="`rating_${rating.id}`"
          :checked="rating.active"
          color="secondary"
          @handleChange="onChange(rating)"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import IRating from "@/interfaces/IRating";

export default defineComponent({
  emits: ["handleRemove", "handleChange"],
  props: {
    rating: {
      required: true,
      type: Object as PropType<IRating>,
    },
  },
  methods: {
    onRemove(id: number) {
      this.$emit("handleRemove", id);
    },
    async onChange(item: IRating) {
      this.$emit("handleChange", item);
    },
  },
});
</script>
